// extracted by mini-css-extract-plugin
export default {"desktopOnly":"ResponsiveBox_desktopOnly__r0MA4","mobileOnly":"ResponsiveBox_mobileOnly__rbOsS"};